import { render, staticRenderFns } from "./AddGroup.vue?vue&type=template&id=e0bd3946&scoped=true"
import script from "./AddGroup.vue?vue&type=script&lang=ts"
export * from "./AddGroup.vue?vue&type=script&lang=ts"
import style0 from "./AddGroup.vue?vue&type=style&index=0&id=e0bd3946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bd3946",
  null
  
)

export default component.exports